import OrderBook from "src/components/feature/OrderBook";

const ForestOrderBook = () => {
  return <OrderBook />;
};

export default ForestOrderBook;
